import { CaregiverDetailsPageContent } from "../../caregiver/pages/CaregiverDetailsPage";

const SharedResidentCarePlanPage = () => (
  <CaregiverDetailsPageContent sharedMode />
);

export default SharedResidentCarePlanPage;
